import { axiosInstance } from "./config"

export const apiGetProvinces = async search => {
    try {
        console.log(search);
        const response = await axiosInstance({
            method: 'POST',
            url: '/provinces',
            data: {
                search
            }
        });
        console.log('API - api get provinces', response.data);
        let data = response.data;

        if (!Array.isArray(data)) {
            return [];
        }

        return data
            .slice(0, 10)
            // TODO: rimuovere questo map
            .map(p => ({ ...p, cap: p.cap || '123123', provincia: p.provincia || "Milano" }))
            .map(p => ({
                ...p,
                cap: Array.isArray(p.cap) ? p.cap : [p.cap],
            }));
    } catch (error) {
        console.log('API - api error get provinces', error);
        throw error;
    }
}